// Returns the backend URL to use for API calls.
// On custom domains, uses relative URLs (empty string) so requests go to the same origin,
// avoiding CORS issues. On preview/development, uses the env variable.
const envUrl = process.env.REACT_APP_BACKEND_URL || '';
const isCustomDomain = typeof window !== 'undefined' &&
  !window.location.hostname.includes('emergentagent.com') &&
  !window.location.hostname.includes('emergent.host') &&
  !window.location.hostname.includes('localhost');

export const BACKEND_URL = isCustomDomain ? '' : envUrl;
